/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupstateclosed2Inputs */

const en_signupstateclosed2 = /** @type {(inputs: Signupstateclosed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

const de_signupstateclosed2 = /** @type {(inputs: Signupstateclosed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlossen`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Signupstateclosed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupstateclosed2 = /** @type {((inputs?: Signupstateclosed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupstateclosed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupstateclosed2(inputs)
	return de_signupstateclosed2(inputs)
});
export { signupstateclosed2 as "signupStateClosed" }